export default function (props: any) {
    const { fillColor, ...restProps } = props;

    return (
        <svg width="100%" height="100%" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg" {...restProps}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-1058.000000, -3868.000000)" fill={fillColor || '#FFFFFF'}>
                    <g transform="translate(827.500000, 3846.000000)">
                        <g transform="translate(31.046881, 15.500000)">
                            <g transform="translate(200.000000, 7.137170)">
                                <path d="M13.4264169,1.48475884 C20.0308191,1.48475884 25.3847449,6.80275226 25.3847449,13.3628296 C25.3847449,19.9229069 20.0308191,25.2409003 13.4264169,25.2409003 C6.82201474,25.2409003 1.46808894,19.9229069 1.46808894,13.3628296 C1.46808894,6.80275226 6.82201474,1.48475884 13.4264169,1.48475884 Z M10.9937082,8.97659101 C10.6461019,8.97659101 10.3643114,9.25838154 10.3643114,9.60598777 L10.3643114,9.60598777 L10.3643114,17.3082126 C10.3643114,17.42371 10.396092,17.5369806 10.456173,17.635621 C10.6369957,17.9324934 11.0242441,18.0265704 11.3211166,17.8457477 L11.3211166,17.8457477 L17.6438265,13.9946353 C17.7296366,13.942369 17.8016869,13.8703187 17.8539532,13.7845086 C18.0347759,13.4876361 17.9406989,13.1003877 17.6438265,12.919565 L17.6438265,12.919565 L11.3211166,9.06845263 C11.2224762,9.00837156 11.1092056,8.97659101 10.9937082,8.97659101 Z"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
